import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import "./rum";
import LoadingSpinner from "components/LoadingSpinner";
import PageWrapper from "components/PageWrapper";

const LoginView = React.lazy(() => import("./Views/LoginView"));
const LogoutView = React.lazy(() => import("./Views/LogoutView"));
const ForgotPasswordView = React.lazy(
  () => import("./Views/ForgotPasswordView")
);
const ResetPasswordView = React.lazy(() => import("./Views/ResetPasswordView"));
const PasswordChangeSuccessView = React.lazy(
  () => import("./Views/PasswordChangeSuccessView")
);

const globalStyles = {
  body: {
    margin: 0,
  },
};

const TreezAuth: React.FC = () => (
  <BrowserRouter>
    <GlobalStyles styles={globalStyles} />
    <div className="App">
      <Suspense fallback={<LoadingSpinner />}>
        <PageWrapper>
          <Routes>
            <Route path="/" element={<LoginView />}>
              <Route
                path=":application/:domain/:callback"
                element={<LoginView />}
              />
            </Route>
            {/* Solution to change route to /signout before fully deprecating /logout redirects */}
            <Route
              path="/logout"
              element={<Navigate to="/signout" replace />}
            />
            <Route path="/signout" element={<LogoutView />} />
            <Route path="/forgot-password" element={<ForgotPasswordView />} />
            <Route path="/reset-password" element={<ResetPasswordView />} />
            <Route
              path="/password-change-success"
              element={<PasswordChangeSuccessView />}
            />
          </Routes>
        </PageWrapper>
      </Suspense>
    </div>
  </BrowserRouter>
);

export default TreezAuth;
